import { z } from 'zod';
export function apiDataSchema(data) {
    return z.object({ data });
}
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string().min(1),
        message: z.string().min(1),
        details: z.unknown().optional(),
        requestId: z.string().min(1).optional(),
    }),
});
export const currencySchema = z.enum(['CAD', 'USD']);
export const moneySchema = z.object({
    amountMinor: z.number().int(),
    currency: currencySchema,
});
export const nonNegativeMoneySchema = moneySchema.extend({
    amountMinor: z.number().int().nonnegative(),
});
export const visibilitySchema = z.enum(['internal', 'client']);
export const demandKindSchema = z.enum(['baseline', 'committed', 'unplanned', 'sales_pipeline']);
export const healthStatusSchema = z.enum(['healthy', 'at_risk', 'critical', 'unknown']);
export const billingReviewStatusSchema = z.enum([
    'pending',
    'approved',
    'flagged',
    'deferred',
    'excluded',
    'credited',
    'invoiced',
]);
export const approvalStatusSchema = z.enum([
    'draft',
    'internal_review',
    'published',
    'approved',
    'rejected',
    'superseded',
]);
export const trackingModeSchema = z.enum(['automatic', 'manual']);
export const tempoAccountStatusSchema = z.enum(['OPEN', 'CLOSED', 'ARCHIVED']);
export const projectWorkTypeSchema = z.enum(['client_billable', 'client_non_billable', 'internal']);
export const commercialModelSchema = z.enum(['fixed_price', 'time_and_materials']);
export const projectScopeSchema = z.enum(['mine', 'all']);
export const projectScopeQuerySchema = z.object({
    scope: projectScopeSchema.default('mine'),
});
export const allocationStatusSchema = z.enum(['hard', 'soft']);
export const allocationEditScopeSchema = z.enum(['week', 'future', 'series']);
export const forecastConfidenceSchema = z.enum(['insufficient', 'low', 'medium', 'high']);
export const capacityHealthSchema = z.enum(['available', 'full', 'overallocated', 'unavailable']);
export const paginationQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(250).default(50),
});
//# sourceMappingURL=common.js.map